
import { useState } from "react";
import { Col } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";


const DynamicCardForm = ({
  title,
  children,
  span = 24,
  xs = 24,
  sm = 24,
  lg,
  xl,
  style,
  bodyStyle,
  className = "",
  noPadding = false,
  noMargin = false,
  margin = false,
  marginBottom = 16,
  marginTop = 0,
  headerRight = null,
  colProps = {},
  collapsable = false,
  defaultOpen = true,
  compact = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const pad = compact ? "14px" : "12px";

  const cardStyle = {
    padding: `0 ${pad} ${pad} ${pad}`,
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    marginBottom: noMargin ? 0 : (margin ? 20 : marginBottom),
    marginTop,
    transition: 'box-shadow 0.3s ease',
    fontSize: '12px',
    minWidth: 0,
    wordBreak: 'break-word',

    ...style,
  };
//
  const headerStyle = {
    background: 'transparent',
    color: '#333',
    padding: '10px 14px 8px 14px',
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: `2px solid #00BFD656`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: collapsable ? 'pointer' : 'default',
    userSelect: collapsable ? 'none' : 'auto',
  };

  const bodyStyleCombined = {
    padding: noPadding ? 0 : '12px 14px',
    fontSize: '14px',
    display: collapsable && !open ? 'none' : undefined,
    ...bodyStyle,
  };

  const handleHeaderClick = () => {
    if (collapsable) setOpen((prev) => !prev);
  };

  return (
    <Col
      span={span}
      xs={xs}
      sm={sm}
      lg={lg || span}
      xl={xl || span}
      {...colProps}
    >
      <div
        className={`dynamic-card-form ${className}`}
        style={cardStyle}
      >
        {title && (
          <div style={headerStyle} onClick={handleHeaderClick}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {collapsable && (
                <span style={{ display: 'inline-flex', alignItems: 'center', color: '#00BFD6' }}>
                  {open ? <DownOutlined /> : <RightOutlined />}
                </span>
              )}
              {title}
            </div>
            {headerRight && (
              <div
                style={{ fontSize: 12, fontWeight: 400, textTransform: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                {headerRight}
              </div>
            )}
          </div>
        )}
        <div style={bodyStyleCombined}>
          {children}
        </div>
      </div>
    </Col>
  );
};

export default DynamicCardForm;